import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(value: any,  search: string): any {
    if  (!search) {return value; }
    let solution = value.filter(v => {
       if ( !v ) {return;}
      return  v.toLowerCase().indexOf(search.toLowerCase()) !== -1;
   })
   return solution;
  }

}
@Pipe({
  name: 'daysAgo'
})
export class DaysAgoPipe implements PipeTransform {
  transform(value: string): string {
    const parsedDate = new Date(value.replace(' ', 'T'));
    const now = new Date();
    const diffTime = now.getTime() - parsedDate.getTime();
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return `${days} days ago`;
  }
}
